var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "authorization"
  }, [_vm.isAuthenticated(_vm.authentication) ? [_c('div', {
    staticClass: "gold"
  }, [_vm._v(_vm._s(_vm.gold))]), _vm._v(" "), _c('div', {
    staticClass: "gold diamond"
  }, [_vm._v(_vm._s(_vm.diamond))]), _vm._v(" "), _c('a', {
    staticClass: "recharge",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.rechargeHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.recharge')))])] : [_c('a', {
    staticClass: "login",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.loginHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.login')))])]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };